// TestimonialsSwiper.jsx

import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import somseImg from '../assets/images/testimonial/pierre.png';
import atunImg from '../assets/images/testimonial/atun.png';
import dgNacaImg from '../assets/images/testimonial/dgNaca.png';
import luciaImg from '../assets/images/testimonial/lucia.png'

const testimonials = [
  {
    name: 'HE Dr. Pierre Somse',
    title: 'Ministre de la Santé Publique et de la Prévention, RCA',
    quote: `Strengthening digital health and evidence-based decision is key strategy to making health accessible to ALL. In this mission Ministry of Health of Central African Republic is proud to launch Digital Transformation Strategy led by Dure Technologies`,
    image: somseImg,
  },
  // {
  //   name: 'DG NACA',
  //   title: 'Dr. Temitope Ilori, PhD, MBBS, Director-General, The National Agency for the Control of AIDS (NACA)',
  //   quote: ``,
  //   image: dgNacaImg,
  // },
  {
    name: 'Dr Lucia Ditiu',
    title: 'Executive Director of the Stop TB Partnership',
    quote: `OneImpact puts communities at the center of the TB response.  

With support from Dure Technologies, it empowers people affected by TB to raise their voices, access care, and drive more accountable and inclusive services`,
    image: luciaImg,
  },
    {
    name: 'Dr Rifat Atun',
    title: 'Vice Dean, Harvard University',
    quote: `The Changing Diabetes in Children program, led by Novo Nordisk, Harvard, and Dure Technologies, is improving type 1 diabetes care in low-resource settings through patient care, research, and digital innovation; showcasing the impact of global health collaboration.
 `,
    image: atunImg,
  },
  
];

const Testimonial = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#0A1A45',
        py: 6,
        px: { xs: 2, md: 8 },
        color: '#fff',
      }}
      className="testimonialSection"
    >
      <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={40}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                textAlign: 'center',
                px: 2,
              }}
            >
              <Avatar
                src={testimonial.image}
                alt={testimonial.name}
                sx={{
                  width: 160,
                  height: 160,
                  mx: 'auto',
                  mb: 2,
                  // border: '4px solid gold',
                }}
              />
              <Typography
                variant="body2"
                sx={{ fontStyle: 'italic', color: '#dcdcdc', mb: 1 , p:4 , height:'140px' , pb:3 }}
                className='quoteMobileheight'
              >
                {testimonial.quote}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ color: '#c170ff', fontWeight: 'bold' , letterSpacing:'0.69px' }}
              >
                {testimonial.name}
              </Typography>
              <Typography variant="body2" sx={{ color: '#ccc' }}>
                {testimonial.title}
              </Typography>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default Testimonial;
